import * as React from 'react';
import { cn } from '@/lib/utils';

interface PageHeaderProps {
  title: string;
  badge?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

export function PageHeader({ title, badge, actions, className }: PageHeaderProps) {
  return (
    <header className={cn('@container/page-header flex flex-col gap-3 @[860px]/page-header:flex-row @[860px]/page-header:items-start @[860px]/page-header:justify-between', className)}>
      <div className="@container/page-header min-w-0 space-y-1">
        {badge ? <div>{badge}</div> : null}
        <h1 className="text-xl font-semibold tracking-tight @[860px]/page-header:text-2xl">{title}</h1>
      </div>
      {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
    </header>
  );
}
